<template>
  <div>
    <list
      row-key="PurchaseArrivalId"
      ref="list"
      unit="销货单明细"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :delete-func="api.delete"
      isSumData
      :get-data-func="api.backDetailsList"
      show-summary  
      :summary-method="getSummaries"
      :pageSizes="[10, 20, 30, 40, 100, 1000]"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单据编号">
          <el-input size="mini" clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="商品名称">
         <el-input size="mini" clearable v-model="params.GoodsName" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="往来单位">
          <!-- <select-input
            placeholder="请选择单位"
            :label="params.CustomerName"
            v-model="params.CustomerId"
            @click="openTradeunit"
          /> -->
          <customer  @restaurants='setSupplier' :state='params.CustomerName'/>
        </el-form-item>
        <el-form-item label="商品分类" prop="ClassName">
         <!-- <el-input size="mini" clearable v-model="params.ClassName" placeholder="请输入商品分类" /> -->
           <el-input v-model="params.ClassName" @focus="openClass" readonly></el-input>
        </el-form-item>
        <el-form-item label="业务员" prop="ClerkName">
            <el-input v-model="params.ClerkName" placeholder="请选择业务员" @focus="addEmp" readonly></el-input>
        </el-form-item>
        <template>
          <el-form-item label="单据日期">
            <el-date-picker
              v-model="params.DocDateStart"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择开始时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="截止日期">
            <el-date-picker
              v-model="params.DocDateEnd"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择结束时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="所属机构">
            <el-select size="mini" v-model="params.DpId" placeholder="请选择机构" clearable >
              <el-option v-for="(item,key) in DpList" :key="key" :label="item.DpName" :value="item.DpId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单据类型">
            <el-select size="mini" v-model="params.DocType" placeholder="请选择单据类型" clearable >
              <el-option v-for="(item,key) in SourceTypList" :key="key" :label="item.DocTypeName" :value="item.DocType"></el-option>
            </el-select>
          </el-form-item>
        </template>

      </template>
      <template slot="table">
        
        <el-table-column prop="DpName" label="所属机构" min-width="100px" />
      <el-table-column prop="DocNo" label="单据编号"/>
      <el-table-column prop="DocType" label="单据类型"/>
      <el-table-column prop="DocDate" label="单据日期" min-width="100px">
         <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
      </el-table-column>
      <el-table-column label="来往单位" prop="CustomerName"/>
      <el-table-column label="商品编码" prop="GoodsCode" />
      <el-table-column label="商品名称" prop="GoodsName"/>
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="UnitName" label="单位" />
      <el-table-column prop="Quantity" label="数量"/> 
      <el-table-column prop="Price" label="单价">
        <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.Price)}}
          </template>
      </el-table-column>
      <el-table-column prop="Amount" label="金额">
        <template slot-scope="{ row }">
            {{row.Amount}}
          </template>
      </el-table-column>
      <el-table-column prop="Remark" label="备注"/>
      <el-table-column label="商品分类" prop="ClassName"/>
      <el-table-column label="业务员" prop="ClerkName"/>
      <!--<el-table-column prop="ExistQuantity" label="现存量" />
      <el-table-column prop="AvailableQuantity" label="可用量 " />-->
      <el-table-column prop="Offer" label="报价">
        <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.Offer)}}
          </template>
      </el-table-column>
      <el-table-column prop="Discount" label="折扣%"/>
     
      <el-table-column prop="TaxRate" label="税率/%"/>
      <el-table-column prop="TaxAmount" label="税额">
        <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.TaxAmount)}}
          </template>
      </el-table-column>
      
      <el-table-column prop="" label="参与活动"/>
      <el-table-column prop="ReferenceCost" label="预估成本单价" min-width="150px">
        <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.ReferenceCost)}}
          </template>
      </el-table-column>
      <el-table-column prop="GrossProfit" label="毛利">
        <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.GrossProfit)}}
          </template>
      </el-table-column>
      
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
      
    </list>

    <tradeunit-dialog ref="tradeunitDialog" selectable @select="setTradeunit" />
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <class-dialog ref="classDialog" selectable multiple  @select="setClass" title="商品分类"/>
  </div>
</template>
<script>
import customer from "@/components/common/customer/customer";
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import empDialog from "@/components/sales/business/empDialog";
import tradeunitDialog from "@/components/basicinfo/basic/logistics/listDialog";
import classDialog from "@/components/basicinfo/goods/archives/goodsTree/listDialog";
export default {
  mixins: [listMixin],
  components: { list,tradeunitDialog,empDialog,classDialog,customer },
  data() {
    return {
      api: require("@/api/sale/saDoc").default,
      dpApi: require("@/api/ent/dp").default,
      params: {
         GoodsName:"",
         DocNo:"",
         DocDateStart:this.$dayjs()
        //.subtract(1, "day")
        .format("YYYY-MM-DD"),
         DocDateEnd:this.$dayjs()
        //.subtract(1, "day")
        .format("YYYY-MM-DD"),
         IdChain:"",
         ClassName:"",
         ClerkId:"",
         ClerkName:"",
         CustomerId:"",
         CustomerName:"",
        DpId:null//所属门店
      },
      isMB: this.$store.state.isMB,
      Amount:0,
      DpList:[],
      SourceTypList:[
        {DocType: '销货单', DocTypeName: '销货单'},
        {DocType: '销货退货单', DocTypeName: '销货退货单'},

      ]
    };
  },
  created(){
    this.dpApi.parentList({DpType:1}).then(res => {
       
       this.DpList = res.Data;
     })
  },
  computed: {
    date() {
      return [this.params.MonthStart, this.params.MonthEnd];
    },
    sDate() {
      return this.$dayjs().endOf("month").format("YYYY-MM-DD");
    },
    eDate() {
      return this.$dayjs()
        .subtract(3, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
    },
  },
  methods: {
   
    setSupplier(data) {
      
      this.params.CustomerId = data.TradeUnitId;
      this.params.CustomerName = data.TradeUnitName;
    },
    onExport() {
      this.api.export(this.params);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const fieldsToSum = ['Quantity', 'Amount', 'TaxAmount', 'GrossProfit'];
      const sums = [];
      sums[0] = "当页合计";
      columns.forEach((column, index) => {
        if (fieldsToSum.includes(column.property)) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            const sum = values.reduce((prev, curr) => {
              const value = Number(curr);
              return !isNaN(value) ? prev + value : prev;
            }, 0);
            if (column.property === 'Quantity') {
              sums[index] = sum.toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4 });
            } else {
              sums[index] = sum.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
          } else {
            sums[index] = "0.00";
          }
        } else {
          if (sums[index] === undefined) {
            sums[index] = ""; 
          }
        }
      });
      return sums;
    },
    setEmp(e) {
      this.params.ClerkId = e.EmpId
      this.params.ClerkName = e.EmpName
    },
    setClass(data) {
      
      this.params.IdChain = data.IdChain;
      this.params.ClassName = data.ClassName;
    },
    openClass() {
      this.$refs.classDialog.open().then((that) => {
        that.getData({ Status: 1, ClassType: 6 });
      });
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    addEmp() {
      // let ids = this.PriAdjustEmpList.map((x) => x.EmpId);
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setTradeunit(data) {
      this.params.CustomerId = data.Id;
      this.params.CustomerName = data.Name;
    },
    dateChange(val) {
      this.params.DocDateStart = val.Start;
      this.params.DocDateEnd = val.End;
    },
    monthChange(val) {
      this.params.MonthStart = val.Start;
      this.params.MonthEnd = val.End;
    },
    onClick(row) {
      
      this.$refs.listDialog.open().then((that) => {
        var params = {
          TradeUnitId: row.TradeUnitId,
          TradeUnitName: row.TradeUnitName,
          DocDateStart: this.params.DocDateStart,
          DocDateEnd: this.params.DocDateEnd,
        };
        that.query(params);
      });
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.params.DocDateStart = start;
      this.params.DocDateEnd = end;
      this.query();
    },
  },
};
</script>